<template>
<div class="card card-custom" v-loading="loading">
    <div class="card-header">
        <h3 class="card-title align-items-start flex-column py-3">
            <div class="d-flex align-items-center">
                <span class="card-label font-weight-bolder text-dark" v-text="title"></span>
                <span v-if="details.length!=0 && details.mstatus==1" class="svg-icon svg-icon-1 svg-icon-success"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                        <path d="M10.0813 3.7242C10.8849 2.16438 13.1151 2.16438 13.9187 3.7242V3.7242C14.4016 4.66147 15.4909 5.1127 16.4951 4.79139V4.79139C18.1663 4.25668 19.7433 5.83365 19.2086 7.50485V7.50485C18.8873 8.50905 19.3385 9.59842 20.2758 10.0813V10.0813C21.8356 10.8849 21.8356 13.1151 20.2758 13.9187V13.9187C19.3385 14.4016 18.8873 15.491 19.2086 16.4951V16.4951C19.7433 18.1663 18.1663 19.7433 16.4951 19.2086V19.2086C15.491 18.8873 14.4016 19.3385 13.9187 20.2758V20.2758C13.1151 21.8356 10.8849 21.8356 10.0813 20.2758V20.2758C9.59842 19.3385 8.50905 18.8873 7.50485 19.2086V19.2086C5.83365 19.7433 4.25668 18.1663 4.79139 16.4951V16.4951C5.1127 15.491 4.66147 14.4016 3.7242 13.9187V13.9187C2.16438 13.1151 2.16438 10.8849 3.7242 10.0813V10.0813C4.66147 9.59842 5.1127 8.50905 4.79139 7.50485V7.50485C4.25668 5.83365 5.83365 4.25668 7.50485 4.79139V4.79139C8.50905 5.1127 9.59842 4.66147 10.0813 3.7242V3.7242Z" fill="#00A300"></path>
                        <path class="permanent" d="M14.8563 9.1903C15.0606 8.94984 15.3771 8.9385 15.6175 9.14289C15.858 9.34728 15.8229 9.66433 15.6185 9.9048L11.863 14.6558C11.6554 14.9001 11.2876 14.9258 11.048 14.7128L8.47656 12.4271C8.24068 12.2174 8.21944 11.8563 8.42911 11.6204C8.63877 11.3845 8.99996 11.3633 9.23583 11.5729L11.3706 13.4705L14.8563 9.1903Z" fill="white"></path>
                    </svg>
                </span>
                <div v-if="details.length!=0" :class="'btn btn-sm btn-light-'+details.param1+' ml-2 py-1 px-3'" ariadescribedby="el-popper-3403">{{details.nstatus}}</div>
            </div>
            <span class="text-muted font-weight-bold font-size-sm">Confirme su participando completando este formulario</span>
        </h3>
    </div>
    <div class="card-body">
        <div class="row p-5 mb-10 border border-secondary rounded border-dashed bg-gray-100">
            <div class="col-sm-4">
                <div class="font-weight-bold text-muted mb-1">Estado del formulario:</div>
                <div class="font-weight-bolder font-size-6" v-html="statusNameForm()"></div>
            </div>
            <!--statusNameForm()-->
            <div class="col-sm-4">
                <div class="font-weight-bold text-muted mb-1">Fecha de creación:</div>
                <div class="font-weight-bolder text-gray-800 d-flex align-items-center flex-wrap">
                    <span class="text-capitalize">{{$moment(form1.date_start).format("DD MMM YYYY")}}</span>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="font-weight-bold text-muted mb-1">Fecha de cierre:</div>
                <div class="font-weight-bolder text-gray-800 d-flex align-items-center flex-wrap">
                    <span class="text-capitalize pr-2">{{$moment(form1.date_end).format("DD MMM YYYY")}}</span>
                    <span class="text-danger d-flex align-items-center">
                        <!--<span class="bullet bullet-dot bg-danger mr-2"></span>Finaliza en 7 días--></span>
                </div>
            </div>
        </div>

        <el-form ref="refIntention" :model="formIntention" status-icon :rules="rules" label-position="left">

            <div class="row">
                <div class="col-sm-12">
                    <h3 class="font-size-h6 font-weight-bolder mb-5">Información de la Institución</h3>
                </div>
            </div>

            <div class="row mx-auto ">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">
                    Institucion
                </div>
                <div class="col-sm-5 border">
                    <el-form-item prop="institution" class="my-2">
                        <el-select v-model="formIntention.institution" size="small" placeholder="Pais/Región" class="w-100">
                            <el-option :value="formIntention.institution" :label="formIntention.business"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="col-sm-1 border bg-primary-o-20 d-flex align-items-center">
                    País
                </div>
                <div class="col-sm-4 border">
                    <el-form-item prop="country" class="my-2">
                        <el-select v-model="formIntention.country" size="small" placeholder="Pais/Región" class="w-100">
                            <el-option :value="formIntention.country" :label="formIntention.country_name"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>

            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Dirección</div>
                <div class="col-sm-10 border">
                    <el-form-item prop="address" class="my-2">
                        <el-input v-model="formIntention.address" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Ciudad</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="city" class="my-2">
                        <el-input v-model="formIntention.city" size="small" maxlength="50" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Código Postal</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="postalcode" class="my-2">
                        <el-input v-model="formIntention.postalcode" size="small" maxlength="50" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Teléfonos</div>
                <div class="col-sm-4 border">
                    <el-form-item label="Código del país" prop="phonecode" class="mt-0 mb-2">
                        <el-select v-model="formIntention.phonecode" filterable placeholder="Seleccione" size="small" :disabled="formIntention.disabled">
                            <el-option v-for="item in callcodes" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>

                        <!--<el-input v-model="formIntention.phonecode" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>-->
                    </el-form-item>
                </div>
                <div class="col-sm-3 border">
                    <el-form-item label="#1" prop="phone1" class="mt-0 mb-2">
                        <el-input v-model="formIntention.phone1" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
                <div class="col-sm-3 border">
                    <el-form-item label="#2" prop="phone2" class="mt-0 mb-2">
                        <el-input v-model="formIntention.phone2" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">E-mail</div>
                <div class="col-sm-10 border">
                    <el-form-item prop="email" class="my-2">
                        <el-input v-model="formIntention.email" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
            </div>

            <hr>

            <div class="row">
                <div class="col-sm-12">
                    <h3 class="font-size-h6 font-weight-bolder mb-5">Información de contacto</h3>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Nombres completos</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="firstname" class="my-2">
                        <el-input v-model="formIntention.firstname" size="medium" maxlength="50" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Apellidos completos</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="lastname" class="my-2">
                        <el-input v-model="formIntention.lastname" size="medium" maxlength="50" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Género</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="gender" class="my-2">
                        <el-radio-group v-model="formIntention.gender" size="small" :disabled="formIntention.disabled">
                            <el-radio-button :label="'M'" class="mb-0">Masculino</el-radio-button>
                            <el-radio-button :label="'F'" class="mb-0">Femenino</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Función</div>
                <div class="col-sm-4 border">
                    <el-form-item prop="function" class="my-2">
                        <el-input v-model="formIntention.function" size="small" maxlength="50" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">Teléfonos</div>
                <div class="col-sm-4 border">
                    <el-form-item label="Código del país" prop="cphonecode" class="mt-0 mb-2">
                        <el-select v-model="formIntention.cphonecode" filterable placeholder="Seleccione" size="small" :disabled="formIntention.disabled">
                            <el-option v-for="item in callcodes" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>

                        <!--<el-input v-model="formIntention.cphonecode" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>-->
                    </el-form-item>
                </div>
                <div class="col-sm-3 border">
                    <el-form-item label="Móvil" prop="cphone1" class="mt-0 mb-2">
                        <el-input v-model="formIntention.cphone1" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
                <div class="col-sm-3 border">
                    <el-form-item label="Oficina" prop="cphone2" class="mt-0 mb-2">
                        <el-input v-model="formIntention.cphone2" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="row mx-auto">
                <div class="col-sm-2 border bg-primary-o-20 d-flex align-items-center">E-mail</div>
                <div class="col-sm-10 border">
                    <el-form-item prop="cemail" class="my-2">
                        <el-input v-model="formIntention.cemail" size="small" maxlength="100" :disabled="formIntention.disabled"></el-input>
                    </el-form-item>
                    <!--<p v-else v-text="formIntention.cemail" class="border rounded my-2 py-2 px-4 bg-light"></p>-->
                </div>
                
            </div>
            
            <div v-if="finaliza">
                <hr>
                <div v-if="details.length==0 || details.mstatus==0" class="btn btn-secondary mr-3" @click="saveAsDraf">Guardar como borrador</div>
                <div v-if="details.length==0 || details.mstatus==0 || details.mstatus==2" class="btn btn-primary" @click="saveAndSend('refIntention')">Guardar y enviar</div>
            </div>

        </el-form>
    </div>
</div>
</template>

<script>
import code from "@/core/config/status.code";
import {
    mapGetters
} from "vuex";

//services
import acrService from '@/core/services/acr.service';

export default {
    name: 'Intention',
    props: {
        title: {
            type: String,
            required: true,
            default: null
        },
        idevent: {
            type: String,
            required: true,
            default: null
        }
    },
    data: () => ({
        loading: false,
        formIntention: {
            save: 0,
            idevent: null,
            institution: null,
            business: null,
            country: null,
            country_name: null,
            address: null,
            city: null,
            postalcode: null,
            phonecode: null,
            phone1: null,
            phone2: null,
            email: null,
            firstname: null,
            lastname: null,
            gender: null,
            function: null,
            cphonecode: null,
            cphone1: null,
            cphone2: null,
            cemail: null,
            mstatus: null,
            param1: null,
            nstatus: null,
            disabled: false
        },
        form1: {},
        details: [],
        finaliza: false,
        rules: {
            institution: [{
                required: true,
                message: "Se requiere nombre de la institución",
                trigger: ['blur', 'change']
            }],
            country: [{
                required: true,
                message: "Se requiere país",
                trigger: ['blur', 'change']
            }],
            address: [{
                required: true,
                message: "Se requiere dirección",
                trigger: ['blur', 'change']
            }],
            city: [{
                required: true,
                message: "Se requiere Ciudad",
                trigger: ['blur', 'change']
            }],
            postalcode: [{
                required: true,
                message: "Se requiere código postal",
                trigger: ['blur', 'change']
            }],
            firstname: [{
                required: true,
                message: "Se requiere nombres completos",
                trigger: ['blur', 'change']
            }],
            lastname: [{
                required: true,
                message: "Se requiere apellidos completos",
                trigger: ['blur', 'change']
            }],
            gender: [{
                required: true,
                message: "Seleccione genero",
                trigger: ['blur', 'change']
            }],
            function: [{
                required: true,
                message: "Se requiere función que desempeña",
                trigger: ['blur', 'change']
            }],
            phone1: [{
                required: true,
                message: "Se requiere número de teléfono",
                trigger: ['blur', 'change']
            }],
            cphone1: [{
                required: true,
                message: "Se requiere teléfono de oficina",
                trigger: ['blur', 'change']
            }],
            cphone2: [{
                required: true,
                message: "Se requiere teléfono móvil",
                trigger: ['blur', 'change']
            }],
            phonecode: [{
                required: true,
                message: "Se requiere código de llamada del país",
                trigger: ['blur', 'change']
            }],
            cphonecode: [{
                required: true,
                message: "Se requiere código de llamada del país",
                trigger: ['blur', 'change']
            }],
            email: [{
                    required: true,
                    message: "Se requiere dirección de correo",
                    trigger: ['blur', 'change']
                },
                {
                    type: 'email',
                    message: "Ingrese un email válido",
                    trigger: ['blur', 'change']
                }
            ],
            cemail: [{
                    required: true,
                    message: "Se requiere dirección de correo",
                    trigger: ['blur', 'change']
                },
                {
                    type: 'email',
                    message: "Ingrese un email válido",
                    trigger: ['blur', 'change']
                }
            ]
        }
    }),
    computed: {
        ...mapGetters(['callcodes']),
    },
    methods: {
        statusNameForm() {
            try {
                if (Object.keys(this.form1).length === 0)
                    return 'Información no disponible.';

                if (this.form1.mstatus == 'O') {
                    if (this.$moment(this.form1.date_end).diff(this.$moment()) > 0) {
                        this.finaliza = true;
                        return '<span class="text-primary">' + this.form1.nstatus + '</span>';
                    } else
                        return '<span class="text-danger">Cerrado para inscripción</span>'
                } else
                    return this.form1.nstatus;

            } catch (error) {
                return '<span class="text-warning">Información no disponible.</span>';
            }
        },
        async get_data() {
            try {
                this.loading = true;
                const res = await acrService.getFip(this.idevent);
                this.form1 = res.data.config;
                this.details = res.data.details;
                this.formIntention = res.data.details;
                this.$refs['refIntention'].resetFields();
                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async save(method) {
            try {
                this.loading = true;
                this.formIntention.save = method;
                const res = await acrService.saveFip(this.formIntention);
                this.loading = false;
                if (res.status == 201) {
                    this.$notify.success({
                        title: 'Perfecto',
                        message: 'Se guardó la información',
                        dangerouslyUseHTMLString: true
                    });
                    this.get_data();
                } else {
                    this.$notify.danger({
                        title: 'Lo sentimos',
                        message: 'No se pudo registrar la información',
                        dangerouslyUseHTMLString: true
                    });
                }
            } catch (e) {
                this.loading = false;
                if (e instanceof acrError) {
                    this.$alert(e.message.data != '' ? e.message.data.messages.error : e.message.statusText, 'Error ' + e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },

        saveAsDraf() {
            this.save(0);
        },
        saveAndSend(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (!valid)
                    return false;

                this.save(1);
            });
        }
    },
    created() {
        this.get_data();
    }
}
</script>
